<div class="col-md-8">
    <div class="post-item list-event-item">
        <div class="box-content-inner clearfix">
            <h3 class="archive-title" style="margin-top:0;">Anmeldung / Termine</h3>
            <p *ngIf="!teilnehmer">Um einen Termin zu buchen, müssen Sie sich einloggen (<a routerLink="/meinedaten">noch nicht registriert?</a>).</p>
            <p>Da die Anzahl der Lehrgangsplätze limitiert ist, erfolgt die
                Aufnahme nach Maßgabe freier Teilnahmeplätze und des Zeitpunkts der
                Anmeldung.</p>
            <p>Sie erhalten zeitnah nach Ihrer Anmeldung eine Rechnung über die
                Teilnahmegebühr auf die von Ihnen hinterlegte E-Mail-Adresse –
                überprüfen Sie gegebenenfalls auch Ihren Spam Ordner.</p>
            <p><strong>Bitte beachten Sie, dass Ihre Teilnahme erst nach
                Zahlungseingang der Teilnahmegebühr auf dem Konto der ÖBAK garantiert
                ist. Die ÖBAK behält sich vor, bei Nichteinzahlung reservierte
                Kursplätze zu stornieren.</strong></p>
            <p>Die Akademie behält sich das Recht vor, die Durchführung der
                Veranstaltung vor Beginn aus wichtigem Grund abzusagen. In diesem Fall
                wird die bereits einbezahlte Teilnahmegebühr rückerstattet.</p>
            <p>Die Akademie behält sich das Recht auf kurzfristig erforderliche
                Programmänderungen sowie Wechsel des Veranstaltungsortes, Wechsel der
                Vortragenden/ReferentInnen oder notwendige organisatorische Abweichungen
                vor.</p>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <app-kursliste-item *ngFor="let kursItem of kursItems" [kursItem]="kursItem"></app-kursliste-item>
        </div> <!-- /.col-md-12 -->
    </div><!-- /.row -->


    <div *ngIf="totalRecords > 0" class="row navigation">
        <div class="col-md-12">
            <div class="paging-navigation">
                <div class="row">
                    <p-paginator (onPageChange)="onPageChange($event)" [first]="first"
                                 [rows]="rows"
                                 [totalRecords]="totalRecords"
                                 [rowsPerPageOptions]="[5, 10, 15]" [showCurrentPageReport]="true"
                                 currentPageReportTemplate="{first} bis {last} von {totalRecords} ">
                    </p-paginator>
                </div>
            </div>
        </div>
    </div>
</div>
